import React, { useState, useEffect, useCallback } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AppRoot, Box, Text } from '@iqueue/iq-ui';
import { api } from './lib/api';
import Workspace from './Workspace';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ChangePasswordPage from './pages/ChangePasswordPage';

/** Router + auth gate. Everything (auth pages included) is React + iq-ui. */
export default function App() {
  const [auth, setAuth] = useState(null); // null = loading

  const refreshAuth = useCallback(async () => {
    try {
      const data = await api.me();
      setAuth(data);
      return data;
    } catch {
      const data = { authenticated: false };
      setAuth(data);
      return data;
    }
  }, []);

  useEffect(() => { refreshAuth(); }, [refreshAuth]);

  if (auth === null) {
    return (
      <Box>
        <Text variant="body-large" muted>Loading...</Text>
      </Box>
    );
  }

  return (
    <Routes>
      <Route path="/login" element={auth.authenticated
        ? <Navigate to="/" replace />
        : <LoginPage onAuthed={refreshAuth} />} />
      <Route path="/register" element={auth.authenticated
        ? <Navigate to="/" replace />
        : <RegisterPage />} />
      <Route path="/change-password" element={<ChangePasswordPage onAuthed={refreshAuth} />} />
      <Route path="/*" element={auth.authenticated
        ? <AppRoot><Workspace me={auth.username} myRole={auth.role || 'user'} onLoggedOut={() => setAuth({ authenticated: false })} /></AppRoot>
        : <Navigate to="/login" replace />} />
    </Routes>
  );
}
